import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import ProductTemplate from '../../../components/feature/ProductTemplate';
import { useSEO } from '../../../utils/seo';

const LightingPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Wholesale LED Lighting Systems | Direct Import Commercial Fixtures | Energy-Efficient',
    description: 'Direct import wholesale LED lighting systems for commercial contractors and developers. Bulk architectural lighting, LED fixtures, and energy-efficient solutions with factory-direct pricing. Reduce energy costs by up to 75%. Save on building materials with wholesale construction supply serving builders across Canada.',
    keywords: 'wholesale LED lighting, commercial lighting bulk, architectural lighting direct import, bulk construction materials supplier, direct import building materials, save on building materials, LED fixtures wholesale',
    canonical: `${siteUrl}/products/lighting`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: 'LED & Architectural Lighting',
      description: 'Wholesale lighting supplier offering direct import energy-efficient LED systems, fixtures, and architectural lighting solutions. Factory-direct pricing on bulk construction materials for commercial and residential projects.',
      category: 'Lighting',
      brand: {
        '@type': 'Brand',
        name: 'Go Global Inc.',
      },
      offers: {
        '@type': 'AggregateOffer',
        priceCurrency: 'CAD',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Go Global Inc.',
        },
      },
    },
  });

  const productData = {
    category: 'Lighting',
    title: 'LED & Architectural Lighting',
    description: 'Energy-efficient LED systems, fixtures, and architectural lighting solutions for commercial and residential projects.',
    heroImage: 'https://public.readdy.ai/ai/img_res/56ef95a69f96f610128849fdd6239394.jpg',
    benefits: [
      {
        icon: 'ri-price-tag-3-line',
        title: 'Energy Savings',
        description: 'LED technology reduces energy costs by up to 75% versus traditional lighting',
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Long Lifespan',
        description: 'Commercial-grade fixtures with 50,000+ hour rated life',
      },
      {
        icon: 'ri-truck-line',
        title: 'Complete Systems',
        description: 'Fixtures, controls, and accessories delivered as complete packages',
      },
      {
        icon: 'ri-global-line',
        title: 'Global Brands',
        description: 'Access to leading lighting manufacturers worldwide',
      },
    ],
    products: [
      {
        name: 'LED Downlights',
        description: 'Recessed LED fixtures for residential and commercial applications',
        image: 'https://readdy.ai/api/search-image?query=modern%20LED%20recessed%20downlight%20fixtures%20installed%20in%20white%20ceiling%20showing%20clean%20design%20and%20professional%20lighting%20in%20contemporary%20interior&width=600&height=500&seq=lighting-downlight-001&orientation=portrait',
      },
      {
        name: 'Linear LED Systems',
        description: 'Continuous linear lighting for offices and retail spaces',
        image: 'https://readdy.ai/api/search-image?query=sleek%20linear%20LED%20lighting%20system%20mounted%20on%20ceiling%20in%20modern%20office%20space%20showing%20continuous%20illumination%20and%20contemporary%20design&width=600&height=500&seq=lighting-linear-001&orientation=portrait',
      },
      {
        name: 'Pendant Fixtures',
        description: 'Decorative pendant lights for hospitality and residential',
        image: 'https://readdy.ai/api/search-image?query=modern%20pendant%20light%20fixtures%20in%20contemporary%20design%20hanging%20in%20dining%20area%20with%20elegant%20style%20and%20professional%20installation&width=600&height=500&seq=lighting-pendant-001&orientation=portrait',
      },
      {
        name: 'Exterior Lighting',
        description: 'Wall packs, bollards, and landscape lighting systems',
        image: 'https://readdy.ai/api/search-image?query=modern%20exterior%20building%20lighting%20with%20LED%20wall%20fixtures%20and%20landscape%20lights%20showing%20professional%20installation%20and%20architectural%20design%20at%20dusk&width=600&height=500&seq=lighting-exterior-001&orientation=portrait',
      },
      {
        name: 'Emergency Lighting',
        description: 'Exit signs, emergency fixtures, and battery backup systems',
        image: 'https://readdy.ai/api/search-image?query=modern%20LED%20exit%20sign%20and%20emergency%20lighting%20fixtures%20in%20commercial%20building%20showing%20code%20compliant%20installation%20and%20professional%20design&width=600&height=500&seq=lighting-emergency-001&orientation=portrait',
      },
      {
        name: 'Lighting Controls',
        description: 'Dimmers, sensors, and smart lighting control systems',
        image: 'https://readdy.ai/api/search-image?query=modern%20lighting%20control%20panel%20and%20smart%20dimmer%20switches%20on%20wall%20showing%20professional%20installation%20and%20contemporary%20design%20in%20clean%20setting&width=600&height=500&seq=lighting-controls-001&orientation=portrait',
      },
    ],
    specifications: [
      'Energy Star and DLC certified products',
      'Color temperature options: 2700K-5000K',
      'Dimmable and non-dimmable options',
      'Wet location rated fixtures available',
      'Smart lighting and IoT integration',
      'Custom color rendering index (CRI) options',
    ],
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <ProductTemplate data={productData} />
      <Footer />
    </div>
  );
};

export default LightingPage;